import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Event_Card from './Event_Card';
import EventCard from './Card/EventCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports';
import Lottie from 'react-lottie';
import { default as animationData } from '../assets/loader.json';
import { useLocation } from 'react-router';
import { cx } from '@emotion/css';
import * as styles from './events.style.js';
import batchImg from '../assets/images/sports-banner.png';
import bannerIcon from '../assets/images/sports-title.png';
import eventsBaner from '../assets/images/events-banner.png';
import { withAuthenticator } from 'aws-amplify-react';
import { get } from 'lodash';

const bannerMap = {
  Astronomy: require('../assets/images/banner-astronomy.jpeg').default,
  Sports: require('../assets/images/sports-banner.png').default,
  English: require('../assets/images/banner-english.jpeg').default,
  'Brain Puzzles': require('../assets/images/banner-gk.jpeg').default,
  'General Knowledge': require('../assets/images/banner-gk.jpeg').default,
  Mathematics: require('../assets/images/banner-maths.jpeg').default,
};

Amplify.configure(config);
function EventsScreen(props) {
  const [events, set_events] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);

  let data1 = useLocation();

  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();
  //     //////console.log(res)
  //     //////console.log(Auth.user.username)
  //     //////console.log(props.category)
  //     //this.props.setCategory(String(Auth.user.username))

  //     getEventsfromDB(Auth.user.username, jwt);
  //   });
  // };

  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {



          getEventsfromDB(user.attributes['email'], jwt)

        }
        else {
          getEventsfromDB(user.username, jwt)
        }




      });




    } catch (error) {
      // console.log(error)
      Auth.signOut()
    }
  };


  const getEventsfromDB = async (username, jwt) => {
    const category = data1.state;

    var categoryreplace = category.category.replace(/%20/g, ' ');

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        username: username,
        category: categoryreplace,
        eventtype: 'Event',
      }),
    };
    // ////console.log(requestOptions)
    const response = await fetch(
      `https://api.dev.quizwizard.net/quiz/getallevents`,
      requestOptions
    );
    // console.log("Response is : ",response);
    const data = await response.json();
    // console.log("Data is : ",data);
    //////console.log('Output from the API is ')
    //////console.log(data)

    var i, j;
    var loopData = [];
    var count = 0;
    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0])
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j];
        count = count + 1;
      }

      //loopData[i] = data[i]['events']
      // for(j=0; j < data[i]['events']; j++){
      //   ////console.log(data[i]['events'][j])
      //   loopData[count] = data[i]['events'][j]
      //   count = count + 1
      // }
    }
    // ////console.log(data[0]['events'])

    //////console.log(loopData)
    //////console.log(loopData)
    //////console.log(data[0]['events'])
    //set_events(data[0]['events'])
    set_events(loopData);
    set_loadedevents(true);
  };
  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")
    getToken();
    document.title = 'Events';
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  let eventCards = events.map((events) => {
    return (
      <div className="col-md-4">
        <Col className="py-2 border rounded" key={events.id}>
          <EventCard
            imgsrc={'../assets/' + encodeURIComponent(events.name) + '.png'}
            title={events.name}
            key={events.id}
            levels={events.levels}
            totalquestions={events.totalquestions}
            event={events}
            category={data1.state}
          />
          {/* <Event_Category_Card key={eventcategory.id}  eventcategory={eventcategory} /> */}
        </Col>
      </div>
    );
  });
  return (
    <div>
      <div className={cx(styles.batchBanner)}>
        <img
          src={bannerMap[get(data1, 'state.category')] || eventsBaner}
          alt=""
        />
      </div>
      <div className={cx(styles.batchTitle)}>
        {get(data1, 'state.category', 'Sports')} events
      </div>
      {loadedevents ? (
        <div>
          <div className={cx(styles.cardEventsDetailsFluid)}>
            <Row>{eventCards} </Row>
          </div>
        </div>
      ) : (
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      )}
    </div>
  );
}

export default withAuthenticator(EventsScreen, false);
